type RoleLike = {
  id?: string
  uid?: string
  agencyId?: string
  createdBy?: string
  role?: string | null
  primaryRole?: string | null
  isAgencyOwner?: boolean
}

type AgencyLike = {
  ownerUserId?: string
}

export function getDisplayRoleLabel(user?: RoleLike | null, agency?: AgencyLike | null): string {
  const role = user?.primaryRole || user?.role

  if (!role) {
    return 'User'
  }

  const authUid = user.uid || user.id
  const isOwner = role === 'admin' && (
    user.isAgencyOwner === true
    || Boolean(agency?.ownerUserId && authUid && agency.ownerUserId === authUid)
    || Boolean(authUid && user.agencyId === authUid)
    || Boolean(authUid && user.createdBy === authUid)
  )

  if (isOwner) {
    return 'Owner'
  }

  return role
    .split('_')
    .map(segment => segment.charAt(0).toUpperCase() + segment.slice(1))
    .join(' ')
}
